import { render, staticRenderFns } from "./resetPwd2.vue?vue&type=template&id=0a4bfdae&scoped=true"
import script from "./resetPwd2.vue?vue&type=script&lang=js"
export * from "./resetPwd2.vue?vue&type=script&lang=js"
import style0 from "./resetPwd2.vue?vue&type=style&index=0&id=0a4bfdae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4bfdae",
  null
  
)

export default component.exports